import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MJAuthBase } from "@memberjunction/ng-auth-services";
import { Observable, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { LogStatus, LogError } from '@memberjunction/core';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    constructor(
        public authBase: MJAuthBase
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Handle authentication check with timeout and error handling
        return this.authBase.isAuthenticated().pipe(
            timeout(10000), // 10 second timeout
            map((isAuthenticated: boolean) => {
                if (isAuthenticated) {
                    return true;
                } else {
                    LogStatus('User not authenticated, showing login');
                    // Don't redirect, just return false to show login template
                    return false;
                }
            }),
            catchError((error) => {
                LogError('Auth guard error:', undefined, error);
                // On error, assume not authenticated
                return of(false);
            })
        );
    }
}